import { injectable, interfaces } from 'inversify';
import { IObservableArray, makeObservable, observable } from 'mobx';
import { IPagingInfoWithOrder, PaginationInfoDefault } from '../../models/paginationInfo.model';
import { ProjectRole } from '../../models/userRole.model';
import { ImportStage, IProjectImportReport, ProjectStatus } from './projects.model';

export interface IProjectListItem {
  id: string;
  name: string;
  description: string;
  modifiedDate: string;
  status: ProjectStatus;
  imagesCount: number;
  awaitingCount: number;
  annotatedCount: number;
  reviewedCount: number;
  myRejectedCount: number;
  progress: number;
  usersCount: number;
  role: ProjectRole;
  isOwner: string;
  canBePublished: boolean;
  unansweredClarificationsCount: number;
  unansweredClarificationImageId: string;
  imageSizeInMB: number;
}

const defaultProjectsPaging: IPagingInfoWithOrder = {
  ...PaginationInfoDefault,
  orderBy: '',
  orderType: '',
};

export enum ProjectOwnership {
  All = 10,
  My = 20,
  Others = 30,
}

export interface IProjectsStore {
  projectOwnership: ProjectOwnership;
  projectsList: IObservableArray<IProjectListItem>;
  projectsPaging: IPagingInfoWithOrder;

  importReport?: IProjectImportReport;
  importStage: ImportStage;
  importErrorCodes?: IObservableArray<string>;
}

export namespace IProjectsStore {
  export const $: interfaces.ServiceIdentifier<IProjectsStore> = Symbol('PROJECTS_STORE');
}

@injectable()
export class ProjectsStore implements IProjectsStore {
  importStage: ImportStage = ImportStage.STEP1;

  importReport?: IProjectImportReport = undefined;

  projectOwnership: ProjectOwnership = ProjectOwnership.All;

  projectsList: IObservableArray<IProjectListItem> = observable.array([]);

  projectsPaging: IPagingInfoWithOrder = defaultProjectsPaging;

  importErrorCodes: IObservableArray<string> = observable.array([]);

  constructor() {
    makeObservable(this, {
      importStage: observable,
      importReport: observable,
      projectOwnership: observable,
      projectsList: observable,
      projectsPaging: observable,
      importErrorCodes: observable,
    });
  }
}
